import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_client-portal-252/artifacts/ymujr84m_Logo%20blitzz%20%2B%20BYB%20ok%20sans%20fond%20copie.png";

export default function AuthCallback() {
  const { processSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

    if (!sessionId) {
      navigate("/login");
      return;
    }

    processSession(sessionId)
      .then(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        navigate("/login");
      });
  }, [processSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#0b0811" }}>
      <div className="text-center animate-fade-in">
        <img src={LOGO_URL} alt="Blitzz" className="h-12 mx-auto mb-4 animate-pulse object-contain" />
        <p className="text-lg text-slate-300">Connexion en cours...</p>
      </div>
    </div>
  );
}
